var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-extend-menu-section-contents" },
    _vm._l(_vm.sortedMeetingNoteList, function (meetingNote) {
      return _c("RoomChatForm", {
        key: meetingNote.meetingNoteId,
        attrs: {
          type: "meetingNote",
          section: _vm.section,
          item: _vm.itemObj(meetingNote),
          menuList: _vm.menuList(meetingNote),
        },
        on: {
          click: function ($event) {
            return _vm.$emit("onClickItem", meetingNote)
          },
          onClickDelete: _vm.onClickDelete,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }